import axios from "axios";
import { Toast } from "vant";
import { isLocalOrTest } from "@/utils/publicMethods";
//总院测试环境
let baseURL = "";
const test_host = "hissct.mobimedical.cn";
const _host = window.location.host;

if (_host == test_host || isLocalOrTest() || _host == "hlwyy.gyjkk.cn") {
  //测试环境
  baseURL = "https://hlwyy.gyjkk.cn/zyyinterface";
} else {
  //正式环境
  baseURL = "https://hlwyy.gyjkk.cn/zyyinterface";
}

// create an axios instance
const service = axios.create({
  baseURL,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    let openId = sessionStorage.getItem("openId");
    if (openId) {
      config.headers["openId"] = openId;
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.msg == "success" || response.status == 200) {
      return Promise.resolve(res);
    } else {
      Toast(res.info);
      return Promise.reject(res);
    }
  },
  error => {
    console.log("err" + error); // for debug
    Toast(error.response.data.info);
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/services/general-server.js